export const removeGeo = ({ map, sourceName, fillName }) => {
  var fill = map.current.getLayer(fillName);

  if (typeof fill !== "undefined") {
    map.current.removeLayer(fillName);
    map.current.removeSource(sourceName);
  }
};
